import { render, staticRenderFns } from "./InterfaceMock.vue?vue&type=template&id=74709310&scoped=true"
import script from "./InterfaceMock.vue?vue&type=script&lang=js"
export * from "./InterfaceMock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74709310",
  null
  
)

export default component.exports